import React from 'react';
import { Tooltip } from 'antd';
import { contains } from 'ramda';
import cx from 'classnames';

import { ACTIVE_STATUSES, ACTIONS_ENABLED_STATUSES } from 'constants/approvalStatuses';
import { ApprovalSidebarLink } from 'components/common/tableComponents/cellTemplates';
import { REQUEST_SIDEBAR } from 'constants/sidebarTypes';
import CustomIcon from 'components/common/CustomIcon';

const PositionLink = ApprovalSidebarLink(REQUEST_SIDEBAR, 'comment');

export const RequestPosition = (props) => {
    const {  item: { status } } = props;
    return (
       <div className="request-position">
           <PositionLink {...props} />
           { contains(status, ACTIONS_ENABLED_STATUSES) &&
               <Tooltip title={status}>
                   <div className="check-wrap">
                       <CustomIcon type="check" className={cx({'status-active': contains(status, ACTIVE_STATUSES)})} />
                   </div>
               </Tooltip>
           }
       </div>
    );
};
